import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../mfe/MfeLoader";
import { getAgentHostConfig } from "../config/agentHostConfig";
import { useHostNavigate } from "../hooks/useHostNavigate";
import { useViewport } from "../contexts/ViewportContext";

export const Route = createFileRoute("/agent/")({
  component: AgentMfePage,
});

function AgentMfePage() {
  const onNavigate = useHostNavigate();
  const { headerHeight } = useViewport();

  return (
    <div
      className="overflow-hidden"
      style={{ height: `calc(100vh - ${headerHeight}px)` }}
    >
      <MfeLoader
        name="agent"
        props={{ hostConfig: getAgentHostConfig(onNavigate) }}
      />
    </div>
  );
}
